module.exports = __webpack_public_path__ + "res/15-img_dead.fe4a6fabb1c4be5c6e59b4b4dddd721d.png";